import { render, staticRenderFns } from "./turn-apply.vue?vue&type=template&id=39517ba0&scoped=true"
import script from "./turn-apply.vue?vue&type=script&lang=ts"
export * from "./turn-apply.vue?vue&type=script&lang=ts"
import style0 from "./turn-apply.vue?vue&type=style&index=0&id=39517ba0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39517ba0",
  null
  
)

export default component.exports